import { bold_lg, regular_lg } from '../texts/Styles';
import { PlanComparisonState } from './Pricing.Page';
import LoadingIconComponent from '@components/icons/loadingIcon';

export default function PricingIntervalSwitcherComponent({
  planComparisonState,
  interval,
  setInterval,
}: {
  planComparisonState: PlanComparisonState;
  interval: 'monthly' | 'annually';
  setInterval: (interval: 'monthly' | 'annually') => void;
}) {
  const savePercent =
    planComparisonState.type === 'success' &&
    Math.min(
      planComparisonState.data.stripePricesPro.percentDecrease,
      planComparisonState.data.stripePricesPro.percentDecrease,
    );

  return (
    <div className="flex flex-col space-y-6 text-product2-content-primary">
      <div className="flex space-x-2 self-end">
        <span className={`${regular_lg} text-pretty text-center`}>
          Save more than{' '}
          {savePercent ? (
            <span
              className={`text-product2-accent-warning ${bold_lg} min-w-[38px]`}
            >
              {savePercent}%
            </span>
          ) : (
            <LoadingIconComponent className="inline-block h-4 w-4 min-w-[38px] animate-spin"></LoadingIconComponent>
          )}{' '}
          and get{' '}
          <span className={`text-product2-accent-warning ${bold_lg}`}>
            7 days free
          </span>
        </span>

        <ArrowDownComponent></ArrowDownComponent>
      </div>
      <div className="relative flex h-12 w-[350px] rounded-full border-2 border-product2-border-secondary p-0.5">
        <div
          className={`absolute h-10 w-[171px] rounded-full bg-product2-background-accent transition-transform ${
            interval === 'annually' ? 'translate-x-full' : ''
          }`}
        ></div>
        <button
          className={`z-10 flex-1 rounded-full ${
            interval === 'monthly'
              ? 'text-product2-content-primary'
              : 'text-product2-content-secondary hover:text-product2-content-primary'
          } ${regular_lg}`}
          onClick={() => setInterval('monthly')}
        >
          Monthly
        </button>
        <button
          className={`z-10 flex-1 rounded-full ${
            interval === 'annually'
              ? 'text-product2-content-primary'
              : 'text-product2-content-secondary hover:text-product2-content-primary'
          } ${regular_lg}`}
          onClick={() => setInterval('annually')}
        >
          Yearly
        </button>
      </div>
    </div>
  );
}

function ArrowDownComponent() {
  return (
    <svg
      width="23"
      height="32"
      viewBox="0 0 23 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="relative top-[12px]"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.7253 27.6988C14.1966 25.7683 15.2154 23.5204 15.6926 21.1214C16.3099 18.0177 15.9931 14.8007 14.7821 11.8771C13.5711 8.95345 11.5203 6.45459 8.88912 4.69648C6.25794 2.93838 3.1645 2 0 2L1.74845e-07 0C3.56006 3.11231e-07 7.04018 1.05568 10.0003 3.03355C12.9603 5.01141 15.2675 7.82263 16.6298 11.1117C17.9922 14.4008 18.3487 18.02 17.6541 21.5116C17.1 24.2975 15.8967 26.9023 14.1543 29.1201L21.8334 27.5231L22.2406 29.4812L13.1091 31.3803C12.2299 31.5631 11.3688 30.9986 11.186 30.1193L9.28686 20.9878L11.245 20.5806L12.7253 27.6988Z"
        fill="#B89CED"
      />
    </svg>
  );
}
